export const CONVO_STARTER_ID = 'convo-starter';
export const SUMMARIZE_CHANGES_ID = 'summarize-changes-ai-action';
export const JIRA_BOARD_CATCH_UP_ID = 'jira-board-catch-up-rovo-nudge';
